var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeslash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47606 6.0244L5.5244 8.97606C5.13298 8.58465 4.91309 8.05377 4.91309 7.50023C4.91309 7.22614 4.96707 6.95474 5.07196 6.70151C5.17685 6.44829 5.33059 6.21821 5.5244 6.0244C5.71821 5.83059 5.94829 5.67685 6.20151 5.57196C6.45474 5.46707 6.72614 5.41309 7.00023 5.41309C7.55377 5.41309 8.08465 5.63298 8.47606 6.0244Z",
    stroke: "#D9DAE0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3949 3.86578C9.37408 3.09578 8.20741 2.67578 6.99991 2.67578C4.94074 2.67578 3.02158 3.88911 1.68574 5.98911C1.16074 6.81161 1.16074 8.19411 1.68574 9.01661C2.14658 9.73995 2.68324 10.3641 3.26658 10.8658M4.91158 11.8924C5.57658 12.1724 6.28241 12.3241 6.99991 12.3241C9.05908 12.3241 10.9782 11.1108 12.3141 9.01078C12.8391 8.18828 12.8391 6.80578 12.3141 5.98328C12.1216 5.67995 11.9116 5.39411 11.6957 5.12578",
    stroke: "#D9DAE0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04783 7.90866C8.9688 8.31558 8.76998 8.68959 8.47687 8.9827C8.18376 9.27581 7.80974 9.47464 7.40283 9.55366M5.52449 8.97616L1.16699 13.3337M12.8337 1.66699L8.47616 6.02449",
    stroke: "#D9DAE0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeslash);
export default __webpack_public_path__ + "static/media/eyeslash.6d591859d8410343a2e3bc2e246c6f3e.svg";
export { ForwardRef as ReactComponent };